import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-02daef9a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "items-box xag-container" }
const _hoisted_2 = { class: "name xag-ellipsis" }
const _hoisted_3 = { class: "explain" }
const _hoisted_4 = { class: "explain" }
const _hoisted_5 = {
  key: 0,
  class: "no-data-box xag-flex-center"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "device-no-data-icon" }),
  /*#__PURE__*/_createElementVNode("div", null, "暂无设备")
], -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "xag-page__footer" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_header = _resolveComponent("app-header")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_app_header, { title: "报修设备" }),
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cacheFaultDevices, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "item",
          key: item.guid
        }, [
          _createElementVNode("div", _hoisted_2, _toDisplayString(item.showName), 1),
          _createElementVNode("div", _hoisted_3, "SN：" + _toDisplayString(item.serial_number), 1),
          _createElementVNode("div", _hoisted_4, "极加服务：" + _toDisplayString(item.xcare), 1)
        ]))
      }), 128)),
      (!_ctx.cacheFaultDevices.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
        : _createCommentVNode("", true)
    ]),
    _hoisted_8
  ], 64))
}